import type {SocialAccount} from '@Components/social-media/account.vo';
import type {SocialMediaWizardContainerQuery, SocialMediaWizardContentSize} from '@Components/social-media-wizard/social-media-wizard.types';

export interface SocialMediaPostPublishParamsWrapperProps {
  account: SocialAccount;
  size?: SocialMediaWizardContentSize;
}

export const getPublishingParamsContainerMarginClass = (containerQuery: SocialMediaWizardContainerQuery): string => {
  if (containerQuery.isExtraSmallScreen || containerQuery.isSmallScreen) {
    return 'spacing-m-b-8';
  }

  if (containerQuery.isMediumScreen || containerQuery.isLargeScreen || containerQuery.isExtraLargeScreen) {
    return 'spacing-m-b-10';
  }

  return 'spacing-m-b-4';
};
